import { Table } from '@tanstack/react-table';
import React, { FC } from 'react';
import { Load } from '../../../types';
import { L } from 'harmony-language';
import { ConditionalLoadTableRow } from './loads/conditional-load-table-row';
import { isLoadRowEditable } from '../utils/drafts-loads-utils';

interface LoadTableBodyProps {
    table: Table<Load>;
}

export const LoadTableBody: FC<LoadTableBodyProps> = (props) => {
    const { table } = props;

    return (
        <div className='lt-body'>
            {table.getRowModel().rows.length ? table.getRowModel().rows.map(row => {
                const isRowExpanded = row.getIsExpanded();
                const isRowEditable = isLoadRowEditable(isRowExpanded, row.original);

                return (
                    <div key={row.id} className='lt-row-parent'>
                        <ConditionalLoadTableRow
                            isRowExpanded={isRowExpanded}
                            isRowEditable={isRowEditable}
                            row={row}
                        />
                    </div>
                );
            }) : (
                <div style={{ display: 'flex', height: '10rem', justifyContent: 'center', alignItems: 'center' }}>
                    <span>{L.noRecords()}</span>
                </div>
            )}
        </div>
    );
};
